export const getMainCategories = (categories = []) =>
  (categories || []).filter((category) => category.is_main_category)

export const getSubcategoriesForMainIds = (categories = [], mainIds = []) => {
  const selectedMainIds = mainIds || []
  if (!selectedMainIds.length) return []

  const selectedMainIdSet = new Set(selectedMainIds)
  return (categories || []).filter(
    (category) => category.is_subcategory && selectedMainIdSet.has(category.parent)
  )
}

export const pruneSubcategoryIds = (categories = [], mainIds = [], subcategoryIds = []) => {
  const selectedMainIdSet = new Set(mainIds || [])
  return (subcategoryIds || []).filter((subId) => {
    const subcategory = categories?.find((category) => category.id === subId)
    return subcategory && selectedMainIdSet.has(subcategory.parent)
  })
}
